<template>
   <div class="email-keyboard"></div>
</template>

<script>
import KeyboardSimple from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import layout from "simple-keyboard-layouts/build/layouts/french";

export default {
   name: "SimpleKeyboard",
   props: {
      keyboardClass: {
         default: "email-keyboard",
         type: String
      },
      input: {
         type: String
      }
   },
   data () {
      return {
         keyboard:{},
      }
   },
   watch: {
      input(input) {
         this.keyboard.setInput(input);
      }
   },
   mounted() {
      this.keyboard = new KeyboardSimple(".email-keyboard",{
         theme: "simple-keyboard hg-theme-default hg-layout-default",
         onChange: input => this.onChange(input),
         onKeyPress: button => this.onKeyPress(button),
         preventMouseDownDefault: true,
         stopMouseDownPropagation: true,
         disableCaretPositioning: true,
         newLineOnEnter: false,
         maxLength: 55,
         layout: {
            default: [
               "1 2 3 4 5 6 7 8 9 0 {bksp}",
               "a z e r t y u i o p + =",
               "q s d f g h j k l m * {enter}",
               "& w x c v b n @ . - _",
               ".com {space}"
            ]},
            display: {
               "{escape}": "esc ⎋",
               "{tab}": "⇥",
               "{bksp}": "⌫",
               "{enter}": "✓",
               "{lock}": "⬆",
               "{space}": " ",
               "{//}": " ",
               "{shift}": "⇧",
            },
         });
         //let kbd = this.keyboard;

         console.log("keyboard simple " + this.keyboard);
      },
      methods: {
         setInput(val) {
            //let input = e.target.value;
            this.keyboard.setInput(val);
         },
         onChange(input) {
            this.$emit("onChange", input);
         },
         onKeyPress(button) {
            this.$emit("onKeyPress", button);

            if (button === "{enter}")
            this.$emit('enter');
         }
      },
   };
   </script>

   <!-- Add "scoped" attribute to limit CSS to this component only -->
   <style scoped>
   keyboard-component-ui {
      //font-family: "Avenir", Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
      //overflow: visible;
   }

   .email-keyboard {
      font-family: 'Univers Condensed';
      max-width: 850px;
      transform: scale(1.5);
      margin-top: 60px;
      margin-left: auto;
      margin-right: auto;
      pointer-events: auto;
      //overflow: visible;
      background-color: rgba(255, 255, 255, 1));
      -webkit-filter: drop-shadow( 0px 0px 10px rgba(0, 0, 0, .8));
      filter: drop-shadow( 0px 0px 10px rgba(0, 0, 0, .1));
   }
   .email-keyboard.hg-theme-default .hg-button {
      border-radius: 10px;
      box-shadow: none;
      border-bottom: none;
   }


   </style>
